// A szűrés form submit-tal történik, JS nem szükséges.
// Ha AJAX szűrés kell, itt lehet bővíteni.
